import Script from "next/script";
import { GA_ADS_ID, GA4_ID } from "./constants";

/**
 * Google Analytics 스크립트 컴포넌트
 * - Google Ads 전환 추적 (AW-...)
 * - GA4 Analytics (G-...)
 */
export function GtagScript() {
  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ADS_ID}`}
      />
      <Script
        id="gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            // Google Ads 전환 추적
            gtag('config', '${GA_ADS_ID}', {
              page_path: window.location.pathname,
            });
            // GA4 Analytics (Firebase Analytics에서 마이그레이션)
            gtag('config', '${GA4_ID}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />
    </>
  );
}
